// the following is "borrowed" from the react-use in order to fix the SSR issues (https://github.com/streamich/react-use/blob/master/src/useMedia.ts)

import { useEffect, useState } from 'react';
import { theme } from '@fiverr-private/theme';

const isBrowser = typeof window !== 'undefined';
const defaultQuery = `(max-width: ${theme.numericBreakpoints.sm}px)`;

const getInitialState = (query, defaultState) => {
    if (defaultState !== undefined) {
        return defaultState;
    }

    if (isBrowser) {
        return window.matchMedia(query).matches;
    }

    return false;
};

const useMedia = (query = defaultQuery, defaultState = false) => {
    const [state, setState] = useState(getInitialState(query, defaultState));

    useEffect(() => {
        let mounted = true;
        const mql = window.matchMedia(query);

        if (!mql || !mql.addEventListener) {
            setState(false);
            return;
        }
        const onChange = () => {
            if (!mounted) {
                return;
            }
            setState(mql.matches);
        };

        mql.addEventListener('change', onChange);
        setState(mql.matches);

        return () => {
            mounted = false;
            mql.removeEventListener('change', onChange);
        };
    }, [query]);

    return state;
};

export default useMedia;
